import { Box, Button, Card, InlineStack, Tooltip } from "@shopify/polaris";
import React from "react";
import StartRating from "stars-rating";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper/core";
import utils from "../../../../utils/utils";
import "./index.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
SwiperCore.use([Autoplay,Pagination]);

const PremiumItem = ({ item,setReminderModal,setPremiumData,handleDowngradeReminde,handleDifferentModalOpen }) => {

  const router = useHistory();
  const shopify = window.shopify;
  const trimTrailingZeros = (value) => {
    if (typeof value !== "string") return value;

    // 先去掉小数点右侧无用的 0
    value = value.replace(/\.0+$/, "").replace(/(\.\d*?[1-9])0+$/, "$1");

    return value;
  };
  const handleGo = (type)=>{
    if (type === 'private') {
      if (shopify) {
        handleDifferentModalOpen(false,'/admin/customService/inventory','Plan_Page_Modal')
      }else {
        utils.routeJump1(router, '/admin/customService/inventory');
      }
    }
    if (type === 'packaging') {
      if (shopify) {
        handleDifferentModalOpen(false,'/admin/customService/custom-packaging','Plan_Page_Modal')
      }else {
        utils.routeJump1(router, '/admin/customService/custom-packaging');
      }
    }
  }
  const PriceFun = () => {
    let money = item.money;
    let oldMoney = item.money;
    if (item.is_yearly) {
        money = (item.money / 12).toFixed(2);
    }
    if (item.discount > 0) {
        money = (money * item.discount).toFixed(2);
    }
    if (item.is_yearly) {
        oldMoney = (oldMoney).toFixed(2);
    }
    
    
    let text = (
      <Box>
        <InlineStack blockAlign="baseline" gap={200}>
          <Box className="plan_item_price">${trimTrailingZeros(money)}</Box>
          {(item.id !== 0 && item.discount <1) ?<Box className="plan_item_old_price plan_item_price_line">${oldMoney}</Box>:''}
          <Box className="plan_item_price_time">
            <Box>USD/month</Box>
            {/* <Box></Box> */}
          </Box>
        </InlineStack>
      </Box>
    );
    if (item.is_yearly) {
      text = (
            <Box>
              <InlineStack blockAlign="baseline" gap={200}>
                <Box className="plan_item_price">${trimTrailingZeros(money)}</Box>
                <span className="plan_item_price_time">USD/month</span>
                {/* {(item.id !== 0 ) ?  (
                  <Box className="plan_item_old_price"><span >${trimTrailingZeros(money)}</span>/month</Box>
                ):''} */}
              </InlineStack>
            </Box>
          );
    }
    return text;
  };
  const ButtonFun = () => {
    let variant = '';
       if (item.button.includes('Select') || item.button.includes('Start') ) {
         variant = 'primary'
       }
    let text = (
      <Box className="plan_item_btn">
        {item.button !== 'Downgrade' ? <Button onClick={()=>{
          if (item.is_zt) {
            setReminderModal(true)
          }else {
            handleDowngradeReminde(item.id)
            // setPremiumData((prevValue) => ({
            //   ...prevValue,
            //   open: true,
            // }));
          }
        }} loading={item.loading} disabled={item.disabled} variant={variant}>
          {item.button}
        </Button>:<Box onClick={()=>{
           if (item.is_zt) {
             setReminderModal(true)
            return
           }
           handleDowngradeReminde(item.id)
        }}><Button  loading={item.loading} disabled={item.disabled}>{item.button}</Button></Box>}
      </Box>
    );
    if (item?.is_zt) {
          text = (
            <Box className={item?.is_zt ? "plan_item_btn plan_item_btn_disabled" : "plan_item_btn"}>
              <Button onClick={()=>{  
               setReminderModal(true)
              }} loading={item.loading} variant={variant}>
                {item.button}
              </Button>
            </Box>
          );
        }
    return text;
  };
  return (
    <Box>
        {(item.bill_level === 2 || item.bill_level === 5) ? '' : <Box className="new_sub_more_ways">More ways to sell</Box>}
      <Card>
        <Box className="new_premium_item_box">
          <Box className="new_premium_item_box_item">
            <InlineStack blockAlign="center" gap={100}>
              <Box className="plan_item_name">{item.name}</Box>
              <img style={{ verticalAlign: "bottom",fontSize:"20px" }} src={item.title_icon} alt='logo'/>
            </InlineStack>
            <Box className="plan_item_name_dsc">{item.dsc}</Box>
            <Box style={{marginBottom:'10px'}}>
              <PriceFun />
            </Box>
            {item.discount_time !== 0 ? <Box className="new_premium_item_content">
              <Box className="new_premium_item_off">
                <InlineStack gap={200} blockAlign="baseline">
              <Box className="new_premium_item_off_text"> {parseFloat((1 - item.discount) * 100).toFixed(
              0
            )}% OFF</Box>  
              <span>The first month</span>
              </InlineStack>
              </Box>
            </Box>: ''}
            <ButtonFun />
          </Box>
          <Box className="new_premium_item_box_item new_premium_item_box_item_bg">
            <div className="plan_item_common_title">Personal agent services</div>
            <div className="agent_list">
              <Swiper
                spaceBetween={0}
                slidesPerView={1}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: true,
                  }}
                pagination={{ clickable: true }}
                onSlideChange={() => {}}
                onSwiper={(swiper) => {}}
              >
                {item.agent?.map((it, k) => (
                  <SwiperSlide key={k}>
                    <div className="agent_item">
                      <div className="agent_left">
                        <img src={it.avatar ? it.avatar : "/dashboard/manage_r_person.png"} alt="Dropshipman" />
                        {/* <img src={"/sub/supawork.png"} alt="Dropshipman" /> */}
                      </div>
                      <div className="agent_right">
                        <div className="agent_right_name">{it.name}</div>
                        <div className="agent_right_year">
                          <span>
                            {it.service_years}{" "}
                            {it.service_years < 1 ? " year" : " years"} of
                            service experience
                          </span>
                        </div>
                        <div
                          className="agent_right_rating"
                          style={{ position: "relative" ,flexWrap:'wrap' }}
                        >
                          {" "}
                          <StartRating
                            value={it.customer_rating}
                            color1="gray"
                            color2="rgba(253, 176, 34, 1)"
                            half={true}
                            count={5}
                            edit={false}
                            size={16}
                          />
                          <span
                            className="agent_right_rating_span"
                            style={{
                              marginLeft: "5px",
                            }}
                          >
                            {" "}
                            {it.customer_rating > 0 ? it.customer_rating : ""}
                          </span>
                        </div>
                        {/* )} */}
                        
                        <div className="agent_right_tag">
                          {" "}
                          {it.service_tags.map((t, j) => (
                            <span key={j}>{t}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Box>
          <Box className="new_premium_item_box_item new_premium_item_box_item_bg">
            <Box className='plan_item_common_title'>Premium Benefits</Box>
            <Box style={{ margin: "10px 0" }}>
              <Card padding={0}>
                <Box  onClick={()=>handleGo('private')} style={{cursor:'pointer'}}>
                <InlineStack align="space-between" blockAlign="center" wrap={false}>
                  <Box className="plan_item_common_benefits_title"  style={{ lineHeight: 1, marginLeft: "10px",fontWeight:650 }}>
                    Custom Private Storage Solutions
                  </Box>
                  <Box style={{ lineHeight: 1 }}>
                    <img src="/sub/custom_private_box.png" alt="logo" />
                  </Box>
                </InlineStack>
                </Box>
              </Card>
            </Box>
            <Box>
              <Card padding={0}>
              <Box onClick={()=>handleGo('packaging')} style={{cursor:'pointer'}}>
                <InlineStack align="space-between" blockAlign="center" wrap={false}>
                  <Box className="plan_item_common_benefits_title" style={{ lineHeight: 1, marginLeft: "10px",fontWeight:650 }}>
                    Custom Brand Packaging & Cards
                  </Box>
                  <Box style={{ lineHeight: 1 }}>
                    <img src="/sub/custom_packaging_box.png" alt="logo" />
                  </Box>
                </InlineStack>
                </Box>
              </Card>
            </Box>
            <Box className="plan_item_dsc">
              <ul>
                <li>
                  <span>.</span>All Plus benefits
                </li>
                <li>
                  <span>.</span>300 priority expert sourcing requests
                </li>
                <li>
                  <span>.</span>Unlimited product imports
                </li>
              </ul>
              <Box>
              <Tooltip width={240} content={
                   <Box className="plan_item_dsc">
                    <ul>
                        {item.dscList.map((desc,k)=><li key={k}>
                          <InlineStack gap={100} blockAlign="top">
                        <span><svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10ZM15.2071 8.20711C15.5976 7.81658 15.5976 7.18342 15.2071 6.79289C14.8166 6.40237 14.1834 6.40237 13.7929 6.79289L9 11.5858L6.70711 9.29289C6.31658 8.90237 5.68342 8.90237 5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.2071 8.20711Z"
                                      fill="#1A1C1D"
                                    />
                            </svg></span>{desc.p}
                            </InlineStack>
                        </li>)}
                    </ul>
                </Box>
              } hasUnderline>
              <span style={{fontWeight:650}}>More benefits</span>
            </Tooltip>
                      
            </Box>
            </Box>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default PremiumItem;
